import { CreatePackageRequestBody } from "../features/package/packageRequestBody";
import { CreateProductBody } from "../features/product/productSlice";
import { CreateNewCategory } from "../features/setup/setupRequestBody";
// import { NewCategory } from "../types/category";
import { AvailableChapels } from "../types/chapel";
import { SpecialPackageData } from "../types/client";
import { OrderOption } from "../types/order";
import { DateRange } from "../types/reports";
import { GuestLogin, StaffLogin } from "../types/response";
import { CreateNewStaffState, UpdatePassword } from "../types/user";

// export const initialSpecialPackage: SpecialPackageData = {
//     specialPackage: {
//         depositAmount: 0,
//         depositDate: '',
//         receiptNumber: '',
//         id: 0,
//         name: "",
//         categoryInfo: {
//             categoryId: 0,
//             categoryName: ''
//         },
//         sizeInfo: {
//             size: '',
//             sizeId: 0
//         }
//     },
//     items: [],
//     startDate: "",
//     startTime: "",
//     endDate: "",
//     endTime: "",
// };

export const loginCredentialStaff: StaffLogin = {
    email: '',
    password: '',
}

export const loginCredentialGuest: GuestLogin = {
    userName: '',
    clientPin: '',
}

export const initialCategoryData: CreateNewCategory = {
    categoryName: '',
    description: '',
    image: '',
    status: ''
}

export const selectedOptionChapel: AvailableChapels = {
    chapelID: 0,
    chapelName: "All",
}

export const selectedSortOption: OrderOption = {
    id: 0,
    name: "All",
}

export const initialProductState: CreateProductBody = {
    category: null,
        productName: '',
        description: '',
        price: 0,
        size: null,
        image: '',
        type: null,
        addOns: null,
        isAvailable: false,
        isOutOfStock: false,
        productID: null
}

export const initialSelectedSize: OrderOption = {
    id: 0,
    name: "All products",
}

export const initialDateRangeReport: DateRange = {
    from: "", 
    to: "",
}

export const initialUpdatePassword: UpdatePassword = {
    oldPass: '',
    newPass: '',
}

export const defaultCreateNewStaff: CreateNewStaffState = {
    firstName: '',
    lastName: '',
    middleInitial: '',
    email: '',
    role: null,
    password: '',
    status: null,
};